import React, { useRef } from "react";
import { Box, Card } from '@curves/ui-base';

import useEChart from "@Util/hook/useEChart";
import ChartSkeletonLoading from "@Local/Dashboard/Components/ChartSkeletonLoading";
import { tooltipFormatter, adaptPie } from "@Local/Dashboard/dashboard.util";
/********* 新會員益生菌訂購狀況 *********/
const NewMemberProbioticsOrders = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			xAxis: ["已訂購", "未訂購"],
			data: [10, 20],
		},
	} = props;
	const { data = [], centerValueText = "" } = adaptPie(sourceData);
	const isLoading = data.length === 0;
	const title = "新會員益生菌訂購狀況";
	const option = {
		title: {
			text: title,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
		},
		tooltip: {
			trigger: "item",
			formatter: tooltipFormatter,
		},
		legend: {
			bottom: 24,
			left: "center",
			icon: "circle",
			textStyle: {
				fontSize: 14,
				color: "#111827",
			},
		},
		series: [
			{
				name: "訂購狀況",
				type: "pie",
				radius: ["40%", "58%"],
				center: ["50%", "55%"],
				startAngle: 90,
				clockwise: true,
				avoidLabelOverlap: false,
				label: { show: false },
				labelLine: { show: false },
				data: data,
				emphasis: {
					scale: true,
					scaleSize: 8,
					itemStyle: {
						opacity: 1,
						shadowBlur: 12,
						shadowColor: "rgba(0,0,0,0.15)",
					},
				},
			},
		],
		graphic: [
			{
				type: "text",
				left: "center",
				top: "50%",
				style: {
					text: centerValueText + "%",
					fontSize: 36,
					fontWeight: 700,
					fill: "#5B0F74",
					textAlign: "center",
				},
			},
		],
	};
	useEChart(chartDomRef, option);
	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});
export default NewMemberProbioticsOrders;
